export const IconFb = () => (
  <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 43.78">
    <path d="M22,0C9.85,0,0,9.85,0,22c0,11.03,8.12,20.14,18.71,21.73v-15.9h-5.44v-5.78h5.44v-3.85c0-6.37,3.1-9.17,8.4-9.17,2.54,0,3.88.19,4.51.27v5.05h-3.61c-2.25,0-3.03,2.13-3.03,4.53v3.16h6.59l-.89,5.78h-5.69v15.94c10.74-1.46,19.02-10.64,19.02-21.78C44,9.85,34.15,0,22,0Z" fill="#000" strokeWidth="0"/>
  </svg>
);

  